import React from 'react'
import styles from './context-menu.styles'
import injectSheet from 'react-jss'
import MoreButton from 'pobble-components/dist/more-button'
import DropMenu from 'pobble-components/dist/drop-menu'
import ArchiveIcon from 'react-icons/lib/fa/close'
import { openConfirmationDialog } from 'pobble-components/dist/modal/confirmation-dialog'

const ContextMenu = ({ classes, onRemove, assessmentFileId }) => (
  <DropMenu
    button={({ ref, togglePopover }) => (
      <MoreButton forwardedRef={ref} onClick={togglePopover} />
    )}>
    {({ Menu, MenuItem, IconHolder, Separator, closePopover }) => (
      <Menu>
        <MenuItem
          onClick={() => {
            openConfirmationDialog({
              bodyText:
                'Are you sure you want to remove this work from the moderation file?',
              action: () => onRemove(assessmentFileId),
              confirmText: 'Remove',
              cancelText: 'Cancel'
            })
            closePopover()
          }}>
          <IconHolder>
            <ArchiveIcon />
          </IconHolder>
          Remove
        </MenuItem>
      </Menu>
    )}
  </DropMenu>
)

export default injectSheet(styles)(ContextMenu)
